<template>
	<Confirmation :button-options="buttonOptions" @agree="agree" @cancel="cancel">
		<v-card-text class="pa-4">
			<span class="confirmation-message text-body-2" v-html="message"></span>
			<v-form ref="participant-selector" v-if="participants.length > 1">
				<v-select class="mt-3"
					v-model="selectedParticipant"
					:items="participants"
					item-title="studio"
					item-value="studio"
					variant="outlined"
					density="compact"
					label="Select studio"
					:rules="rules.selector"
					return-object
					hide-details/>
			</v-form>
		</v-card-text>
	</Confirmation>
</template>

<script>
import Confirmation from "@/components/dialogs/Confirmation.vue";

export default {
	name: "TransferHostConfirmation",

	components: {Confirmation},

	props: ["message", "participants"],

	emits: ["agree", "cancel"],

	data() {
		return {
			selectedParticipant: null,
			rules: {
				selector: [(v) => (this.participants.length === 1 || !!v) || "Item is required"]
			},
			buttonOptions: {
				agreeBtn: {
					enabled: true,
					message: "Yes"
				},
				cancelBtn: {
					enabled: true,
					message: "No"
				}
			}
		}
	},

	methods: {
		agree() {
			if (this.participants.length === 1) {
				this.$emit("agree", this.participants[0]);
			}
			else {
				this.$refs["participant-selector"].validate().then(({valid}) => {
					if (valid) {
						this.$emit("agree", this.selectedParticipant);
					}
				});
			}
		},

		cancel() {
			this.$emit("cancel");
		}
	}
}
</script>

<style scoped lang="scss">
.confirmation-message {
	white-space: pre-wrap;
	justify-content: center;
	display: flex;
	flex-direction: column;
}

</style>